<template>
  <div class="view-gabarit">
    <div class="view-content">
      <div class="view-line">
        <div v-if="site" class="site-box">
          <div class="image" :style="{ 'background-image': `url(${siteImage})` }"></div>
          <div class="site-info">
            <div class="site-index" :style="{ 'background-image': `url(${sitePOIImage})` }"></div>
            <div class="site-address-container">
              <div class="site-name">{{ site.name }}</div>
              <div class="site-address">{{ site.address }}</div>
            </div>
          </div>
        </div>
        <div v-if="collaborators.length > 0" class="graph-box">
          <div class="graph-title">{{ $t('report.synthesisCollaboratorOrigins') }}</div>
          <CollaboratorsOrigins :data="computedData" />
        </div>
      </div>
      <div v-if="collaborators.length > 0" class="view-line">
        <div class="view-box">
          <div class="view-title">{{ $t('report.outlierBySeniority') }}</div>
          <LabelPieChart :entries="collaboratorsBySeniority" :pieWidth="550" :pieHeight="400" :size="190" />
        </div>
        <div class="view-box">
          <div class="view-title">{{ $t('report.outlierByContractType') }}</div>
          <LabelPieChart :entries="collaboratorsByContractType" :pieWidth="550" :pieHeight="400" :size="190" />
        </div>
        <div class="view-box">
          <div class="view-title">{{ $t('report.outlierByService') }}</div>
          <LabelPieChart :entries="collaboratorsByService" :pieWidth="550" :pieHeight="400" :size="190" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetProvider from '@/pure/assetProvider';
import CollaboratorsOrigins from '@/components/Analysis/Synthesis/CollaboratorOrigins';
import LabelPieChart from '@/components/Chart/LabelPie';

export default {
  components: {
    CollaboratorsOrigins,
    LabelPieChart,
  },

  props: ['index', 'screenData'],

  computed: {
    site() {
      return this.screenData.sites[this.index];
    },

    siteImage() {
      return this.site.picture_path || assetProvider.placeHolderSite;
    },

    sitePOIImage() {
      return assetProvider[`poi${this.site.index + 1}`];
    },

    computedData() {
      const { details } = this.site;
      return {
        collaboratorsByRegion: details.sensibleCollaboratorsByRegion,
        filteredCollaboratorsCount: details.sensibleCaseCollaborators.length,
      };
    },

    averageTime() {
      const { averageTime, averageTimeDiff } = this.site.details.impact.sensibleCaseDecay;
      return {
        trend: averageTimeDiff > 0 ? 'up' : 'down',
        diff: averageTimeDiff,
        value: averageTime,
      };
    },

    collaborators() {
      return this.site.details.sensibleCaseCollaborators;
    },

    collaboratorsByContractType() {
      return this.getSummaryPieByDetails('contractType');
    },

    collaboratorsByService() {
      return this.getSummaryPieByDetails('service');
    },

    collaboratorsBySeniority() {
      return this.getSummaryPieByDetails('seniority');
    },
  },

  methods: {
    getSummaryPieByDetails(key) {
      const summary = this.collaborators.reduce((acc, person) => {
        const currentKey = person.details[key];
        const currentGroup = acc.find(item => item.label === currentKey);
        if (!currentGroup) {
          acc.push({
            label: currentKey,
            count: 1,
          });
        } else {
          currentGroup.count++;
        }
        return acc;
      }, []);

      let i = 0;
      let count = 0;
      let percentage = 0;
      let newSummary = [];
      for (i = 0; i < summary.length; i++) {
        summary[i].percentage = summary[i].count / this.collaborators.length;

        if (summary[i].percentage < 0.06) {
          count += summary[i].count;
          percentage += summary[i].percentage;
        } else {
          newSummary.push(summary[i]);
        }
      }

      if (count > 0) {
        newSummary.push({
          label: this.$t('other'),
          count: count,
          percentage: percentage,
        });
      }

      console.log(newSummary);
      return newSummary.sort((a, b) => b.label - a.label);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.view-gabarit {
  position: absolute;
  padding: 48px 32px;
  box-sizing: border-box;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  .view-line {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .site-box {
      width: 30%;
      padding: 0 32px;
      box-sizing: border-box;

      .image {
        width: 100%;
        height: 30vh;
        background: colors.$dark-grey-color;
        border-radius: 24px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
      }

      .site-info {
        display: flex;

        .site-index {
          flex-shrink: 0;
          width: 64px;
          height: 96px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: contain;
          margin: 24px 16px 24px 24px;
        }
        .site-address-container {
          margin: 24px 0 0 0;

          .site-name {
            font-size: 32px;
            font-weight: 600;
          }
          .site-address {
            font-size: 28px;
            opacity: 0.8;
          }
        }
      }
    }

    .graph-box {
      flex-grow: 1;
      height: 100%;
      max-width: 960px;
      margin: 0 auto;
      padding: 24px 0 48px;
      box-sizing: border-box;

      .graph-title {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }

    .view-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 30%;
      border-top: solid 1px colors.$dark-concrete-color;
      padding: 24px 0;
      box-sizing: border-box;
      overflow: hidden;

      .view-title {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }
  }
}
</style>
